module.exports = __webpack_public_path__ + "static/media/horse_racing.0ec6dd70.webp";